module.exports = __webpack_public_path__ + "assets/4cb02a3c8ccf9df19efab639bbe6f210.png";